var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpMethod } from '../../enums';
import { isLocalhost } from '../../utils/domain';
import { createClient } from './client';
import { getMockedServiceBaseURL, getServiceBaseURL } from './services';
const shouldUseMockServer = (useMockServer) => {
    if (!isLocalhost())
        return false;
    return useMockServer === undefined
        ? process.env.NEXT_PUBLIC_USE_MOCK_SERVER === 'true'
        : useMockServer;
};
const getHttpClient = (req) => __awaiter(void 0, void 0, void 0, function* () {
    const { service, useMockServer, locale, isCaseMapperEnabled, version } = req;
    const baseUrl = shouldUseMockServer(useMockServer)
        ? getMockedServiceBaseURL(service)
        : getServiceBaseURL(service, locale, version);
    return createClient(baseUrl, undefined, isCaseMapperEnabled);
});
export const createHttpRequest = (request) => __awaiter(void 0, void 0, void 0, function* () {
    const { service, url, method, data, settings } = request;
    if (!(service && url)) {
        throw new Error('Missing required parameter (service/url) while calling "request"');
    }
    let client = yield getHttpClient(request);
    const action = method !== null && method !== void 0 ? method : HttpMethod.GET;
    // GET, DELETE (actions without payload)
    if ([HttpMethod.GET, HttpMethod.DELETE].includes(action)) {
        return client[action.toLowerCase()](url, settings);
    }
    // POST, PUT, PATCH  (actions with payload)
    return client[action.toLowerCase()](url, data, settings);
});
//# sourceMappingURL=request.js.map